
const getBase64FromUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};

const generateEstoqueReport = async ({ empresa, data, user, rows }) => {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    const estoqueKey = empresa;
    const reservaKey = `reserva ${empresa}`;

    // carrega a logo em base64
    const logoBase64 = await getBase64FromUrl("/sistema/v10.png");

    const addHeader = () => {
        // Logo no canto esquerdo
        doc.addImage(logoBase64, "PNG", 40, 20, 80, 40);

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("RELATÓRIO ESTOQUE PNEUS", pageWidth / 2, 40, { align: "center" });

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(empresa, pageWidth - 40, 40, { align: "right" });

        doc.setDrawColor(0); // cor preta
        doc.setLineWidth(1);
        doc.line(40, 62, pageWidth - 40, 62); // de margem esquerda até direita


        //Resetando a grossura da linha 
        doc.setLineWidth(0.5);

        // Caixa Header
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.rect(40, 65, pageWidth - 80, 18);
        doc.text(`Impresso por:`, 50, 78);

        doc.setFont("helvetica", "normal")
        doc.text(`${user}`, 60 + doc.getTextWidth("Impresso por:"), 78)

        // Texto em negrito
        doc.setFont("helvetica", "bold");
        const label = "Data Impressão:";
        const labelWidth = doc.getTextWidth(label);
        doc.text(label, pageWidth - 135 - labelWidth, 78); // 135 é a margem direita

        // Texto normal
        doc.setFont("helvetica", "normal");
        doc.text(`${data}`, pageWidth - 130, 78); // 130 começa logo depois do label
    };

    // === Agrupamento e páginas ===
    const aros = rows.reduce((acc, row) => {
        if (!acc[row.aro]) acc[row.aro] = [];
        acc[row.aro].push(row);
        return acc;
    }, {});

    const todosProdutos = Object.entries(aros).flatMap(([aro, produtos]) => {
        const produtosOrdenados = [...produtos].sort((a, b) =>
            a.GrupoSimilaridade.localeCompare(b.GrupoSimilaridade)
        );

        const linhaAro = { tipo: "aro", aro, produtos: produtosOrdenados };

        const linhasProdutos = produtosOrdenados.map((p) => ({
            tipo: "produto",
            aro,
            produto: p,
        }));

        return [linhaAro, ...linhasProdutos];
    });

    const alturaLinha = 20;
    const linhasPorPagina = Math.floor((doc.internal.pageSize.getHeight() - 150) / alturaLinha);

    const paginas = [];
    for (let i = 0; i < todosProdutos.length; i += linhasPorPagina) {
        paginas.push(todosProdutos.slice(i, i + linhasPorPagina));
    }

    const totalEstoqueFisico = rows.reduce((s, r) => s + (r[estoqueKey] || 0), 0);
    const totalEstoqueReserva = rows.reduce((s, r) => s + (r[reservaKey] || 0), 0);
    const totalEstoqueSaldo = totalEstoqueFisico - totalEstoqueReserva;

    const format_id = n => String(n).padStart(5, '0');

    // === Geração das páginas ===
    paginas.forEach((pagina, paginaIndex) => {

        const body = [

            ...(paginaIndex === 0
                ? [[
                    { content: '', styles: { fontStyle: "bold", fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                    { content: 'PNEUS NOVOS', styles: { fontSize: 9, fontStyle: "bold", fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                    { content: totalEstoqueFisico, styles: { fontSize: 9, halign: "center", fontStyle: "bold", fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                    { content: totalEstoqueReserva, styles: { fontSize: 9, halign: "center", fontStyle: "bold", fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                    { content: totalEstoqueSaldo, styles: { fontSize: 9, halign: "center", fontStyle: "bold", fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                    { content: '', styles: { fontStyle: "bold", fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                ]] : []
            ),


            ...pagina.map((linha) => {
                if (linha.tipo === "aro") {
                    const totalFisico = linha.produtos.reduce((sum, p) => sum + (p[estoqueKey] || 0), 0);
                    const totalReserva = linha.produtos.reduce((sum, p) => sum + (p[reservaKey] || 0), 0);
                    const totalSaldo = totalFisico - totalReserva;

                    return [
                        { content: '', styles: { fontStyle: "bold", fillColor: [230, 230, 230] } },
                        { content: linha.aro, styles: { fontSize: 10, textColor: [0, 0, 0], fontStyle: "bold", fillColor: [230, 230, 230] } },
                        { content: totalFisico, styles: { fontSize: 10, textColor: [0, 0, 0], fontStyle: "bold", halign: "center", fillColor: [230, 230, 230] } },
                        { content: totalReserva, styles: { fontSize: 10, textColor: [0, 0, 0], fontStyle: "bold", halign: "center", fillColor: [230, 230, 230] } },
                        { content: totalSaldo, styles: { fontSize: 10, textColor: [0, 0, 0], fontStyle: "bold", halign: "center", fillColor: [230, 230, 230] } },
                        { content: '', styles: { fillColor: [230, 230, 230] } }
                    ];
                }

                if (linha.tipo === "produto") {
                    const p = linha.produto;
                    const fisico = p[estoqueKey] || 0;
                    const reserva = p[reservaKey] || 0;
                    const saldo = fisico - reserva;

                    return [
                        { content: format_id(p.id), styles: { halign: "center", textColor: [0, 0, 0] } },
                        { content: p.Descricao, styles: { halign: "left", textColor: [0, 0, 0] } },
                        { content: fisico, styles: { halign: "center", textColor: [0, 0, 0] } },
                        { content: reserva, styles: { halign: "center", textColor: [0, 0, 0] } },
                        { content: saldo, styles: { halign: "center", textColor: [0, 0, 0] } },
                    ];
                }

                return [];
            }),

            [
                { content: '', styles: { fillColor: [195, 195, 195] } },
                { content: 'Total Estoque', styles: { fontSize: 9, fontStyle: "bold", fillColor: [195, 195, 195], textColor: [0, 0, 0] } },
                { content: totalEstoqueFisico, styles: { fontSize: 9, fontStyle: "bold", halign: "center", fillColor: [195, 195, 195], textColor: [0, 0, 0] } },
                { content: totalEstoqueReserva, styles: { fontSize: 9, fontStyle: "bold", halign: "center", fillColor: [195, 195, 195], textColor: [0, 0, 0] } },
                { content: totalEstoqueSaldo, styles: { fontSize: 9, fontStyle: "bold", halign: "center", fillColor: [195, 195, 195], textColor: [0, 0, 0] } },
                { content: '', styles: { fillColor: [195, 195, 195] } },

            ],
        ];


        const startY = 95; // altura logo + títulos

        doc.autoTable({
            startY,
            head: [["Código", "Nome Produto", "Físico", "Reserv", "Saldo", "Anotação"]],
            body,
            theme: "grid",

            // === Cabeçalho ===
            headStyles: {
                fillColor: [195, 195, 195],   // fundo preto
                textColor: [0, 0, 0], // texto branco
                fontStyle: "bold",
                halign: "left",
                lineWidth: 0.5,
                lineColor: [0, 0, 0] // borda preta
            },

            // === Corpo da tabela ===
            bodyStyles: {
                fontSize: 8,
                lineColor: [0, 0, 0], // linhas pretas
                lineWidth: 0.25
            },

            didDrawPage: function (data) {
                // Desenha o cabeçalho em TODAS as páginas
                addHeader();
            },

            // === Margens ===
            margin: { left: 40, right: 40, top: 95 }, // mesma largura da sua imagem
        });

    });

    doc.save("relatorio-estoque.pdf");
};

export default generateEstoqueReport;
